/**
 * Shared classNames for the segmented "pill" control — a neutral-100 track
 * holding h-7 pills where the active pill lifts to white with a soft shadow.
 * Used by the campaigns stats period selector and the campaigns table status
 * filter so the two controls stay visually identical.
 *
 * Extracted to avoid silent drift between the duplicated long classNames.
 */
export const segmentedPillGroupClass =
  'inline-flex h-9 items-center rounded-lg bg-neutral-100 p-1 gap-1'

/** Compact `sm` track (h-8) — lines up with the DS2026 `size="sm"` controls. */
export const segmentedPillGroupClassSm =
  'inline-flex h-8 items-center rounded-lg bg-neutral-100 p-0.5 gap-0.5'

export const segmentedPillBaseClass =
  'h-7 px-3 text-sm font-medium tracking-[-0.2px] transition-colors whitespace-nowrap flex items-center justify-center rounded-md'

export const segmentedPillActiveClass =
  'bg-white text-neutral-800 shadow-tab-active'

export const segmentedPillInactiveClass =
  'text-neutral-500 hover:text-neutral-800'
